import React, { useState, useCallback } from 'react';
import SubscriptionBasedNotificationForm from './SubscriptionBasedNotificationForm';
import SubscriptionBasedNotificationHistory from './SubscriptionBasedNotificationHistory';

function SubscriptionBasedNotification() {
    const [refreshHistory, setRefreshHistory] = useState(true);

    const refreshNotificationList = useCallback(async (flag) => {
        setRefreshHistory(flag);
    }, []);

    return (
        <>
            <SubscriptionBasedNotificationForm refresh={(flag) => refreshNotificationList(flag)} />
            <br />
            <SubscriptionBasedNotificationHistory
                refreshHistory={refreshHistory}
                refresh={(flag) => refreshNotificationList(flag)}
            />
        </>
    );
}

export default SubscriptionBasedNotification;
